import {type UIChild, UI} from "../../../stem-core/ui/UIBase";
import {StyleSheet, styleRule, registerStyle} from "../../../stem-core/ui/Style";
import {SwitchAccountCard} from "./SwitchAccountCard";
import {Router} from "../../../stem-core/ui/Router";
import {LoadingSpinner} from "../../../core/ui/LoadingSpinner.jsx";
import {merchantService} from "../../misc/MerchantService";
import {Merchant} from "../../../client/state/MerchantStore.js";
import type {NodeAttributes} from "../../../stem-core/ui/NodeAttributes";

export class SwitchAccountPageStyle extends StyleSheet {
    @styleRule
    pageElement = {
        maxWidth: 900,
        margin: "auto",
        paddingTop: 90,
    }
}

@registerStyle(SwitchAccountPageStyle)
export class SwitchAccountPage extends UI.Element {
    extraNodeAttributes(attr: NodeAttributes) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.pageElement);
    }

    render(): UIChild {
        if (!merchantService.isMerchantDataRequestFinished()) {
            return <LoadingSpinner />
        }

        if (Merchant.all().length > 0) {
            Router.changeURL("", {replaceHistory: true});
            return [];
        }

        return <SwitchAccountCard />
    }

    onMount() {
        this.attachListener(merchantService, "merchantDataRequestFinished", () => this.redraw());
    }
}
